/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-return-assign */
/* eslint-disable react/sort-comp */
/* eslint-disable no-use-before-define */

import CopyToClipboard from 'react-copy-to-clipboard';
import shortid from 'short-id';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import { bindActionCreators } from 'redux';
import { toast } from 'react-toastify';
import {
  Segment,
  Button,
  Popup,
  Accordion,
  Icon,
  Tab,
  Grid,
  Form,
  Divider,
  Label,
  Dimmer,
  Loader,
  Image
} from 'semantic-ui-react';
import { updateUrl } from '../../../utils/urls';
import AdPreview from '../../../components/common/AdPreview';
import AdNotesQC from '../../../screens/Flipper/ParentSection/AdNotesQC';
import CanvasPreview from '../../../components/common/CanvasPreview';
import * as AppActions from '../../../actions';
import WrapperAdCheckbox from './WrapperAdCheckbox';
import ModalShareLink from './ModalShareLink';
import { formatMonth } from '../../../utils/format';
import * as presentationBuilderDB from '../../../database/PresentationBuilderDB';
import ErrorReportModal from './ErrorReportModal';
import {
  getColorRow,
  renderPopupQCOrCheckbox,
  renderNoteWarning,
  renderHoldAd,
  renderErrorReport,
  renderDestinationUrls,
  renderLeadFormName,
  renderPopupContent,
  checkIfAdIsForInstagram,
  getInstagramStoryByAdId,
  returnIframeForInstagramStory,
  getPreviews
} from '../../../utils/ad.common';
import {
  getTargetingSentencelines,
  updateAd,
  updateStatusAd
} from '../../../fbApi/Ad';

import getFullNameOrUserName from '../../../utils/user';
import { makePost } from '../../../services/ServiceManager';

class PreviewAccordionItem extends Component {
  constructor(props) {
    super(props);
    const { getFbToken } = this.props; // this.props comes from redux, I think
    this.state = {
      copyLink: '',
      copyLinkOpen: false,
      adIdText: '',
      adIdOpen: false,
      hasPreviewIndex: false,
      shareLink: '',
      adPreview: props.adPreview,
      isPreviewOnHold: false,
      token: getFbToken(),
      previewIndex: 1,
      productSetName: '',
      destinationUrl: '',
      presentation: {
        data: {},
        url: ''
      },
      instagramData: {},
      borderColor: false,
      clickedIndex: -1,
      getTargetingAndPreviewQueries: false
    };

    this.fields = [
      'Year',
      'Month',
      'Client',
      'Campaign',
      'Audience',
      'Placements',
      'Ad Type',
      'Ad Name'
    ];
  }

  componentDidMount() {
    this.loadAdInfo();
  }

  componentDidUpdate(prevProps) {
    const { expandAll: prevExpandAll } = prevProps;
    const { expandAll: currExpandAll } = this.props;
    if (currExpandAll && !prevExpandAll) {
      this.loadAdInfo();
    }
  }

  closeForm = () => {
    this.setState({ showForm: false });
  };

  retrieveSelectedAds = (ad) => {
    const selectedAds = {
      LINK_CLICKS: [],
      VIDEO_VIEWS: [],
      LEAD_GENERATION: [],
      PRODUCT_CATALOG_SALES: [],
      CONVERSIONS: [],
      MESSAGES: [],
      POST_ENGAGEMENT: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    };
    selectedAds[ad.campaignObjective] = [{ id: ad.ad_id, name: ad.ad_name }];
    return selectedAds;
  };

  saveOrUpdatedPresentation = async (ad) => {
    const presentationData = {};
    const { presentation } = this.state;
    const {
      campaignMonthName,
      adAccountName,
      selectedYear,
      user,
      selectedAccounts,
      campaign_ids,
      update
    } = this.props;
    presentationData.campaigns = {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: [],
      MESSAGES: [],
      POST_ENGAGEMENT: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    };

    const presentationTitleCustom = 'CUSTOM - ';
    const formatMonthText = formatMonth(campaignMonthName);
    presentationData.title = `${presentationTitleCustom}${adAccountName} - ${formatMonthText} ${selectedYear}`;

    // if presentation already exists (unique name is set) don't update the share link!
    presentation.url = `${shortid.generate()}${shortid.generate()}${shortid.generate()}`;
    presentation.data = JSON.stringify(presentationData);
    presentation.username = user.email;
    presentation.active = true;
    presentation.cachedquery = JSON.stringify({
      account_id: selectedAccounts,
      month_year: campaignMonthName,
      campaign_ids,
      ads_ids: this.retrieveSelectedAds(ad),
      is_multiple_accounts: false,
      is_custom_ads: true
    });
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 15);
    presentation.createdAt = new Date();
    presentation.updatedAt = new Date();
    presentation.expiredAt = expirationDate.toISOString().split('T')[0];
    const presentationCustomName = `CUSTOM - ${new Date().getTime()} `;
    presentation.name = `${presentationCustomName}${adAccountName} ${campaignMonthName} ${selectedYear}`;

    this.setState({ presentation });
    try {
      await this.props.submit(presentation);
      this.setState({
        shareLink: this.presentation.url,
        presentationSaved: 'new'
      });
    } catch (error) {
      // failed to save? do we have a collison in the name field?
      const updatedPresentation = await update(presentation);
      this.setState({
        presentationSaved: 'update',
        shareLink:
          updatedPresentation.data.updatePresentationByName.presentation.url
      });
    }
  };

  onCopyAdContent = (adContent) => {
    if (adContent && adContent.trim !== '') {
      toast(`"${adContent}" copied to clipboard.`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
        type: toast.TYPE.DEFAULT,
        hideProgressBar: true
      });
    } else {
      toast(
        `Content is missing or it was left intentionally blank. 
         Check the Ad's content on Facebook, and then try again.`,
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 4000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        }
      );
    }
  };

  getTabAds = (preview) => {
    const { instagramData } = this.state;
    const { data: instagramStoryIframeData } = instagramData;
    const onlyMobile = preview.desktop_iframe_url
      ? preview.desktop_iframe_url.indexOf('mobile-only') >= 0
      : false;
    const desktopAd = {
      menuItem: { key: 'Desktop', icon: <Icon size="large" name="desktop" /> },
      pane: <Tab.Pane>{this.renderDesktopAd(preview)}</Tab.Pane>
    };

    const mobileAd = {
      menuItem: { key: 'Mobile', icon: <Icon size="big" name="mobile" /> },
      pane: <Tab.Pane>{this.renderMobileAd(preview)}</Tab.Pane>
    };

    const instagramStory = {
      menuItem:
        instagramStoryIframeData && instagramStoryIframeData.length > 0
          ? {
              key: 'Instagram Story',
              icon: <Icon size="big" name="instagram" />
            }
          : {},
      pane: <Tab.Pane>{this.renderInstagramStoryAd()}</Tab.Pane>
    };

    const mobileDesktop = (
      <div className="icons-container">
        <Icon size="big" name="mobile" /> +{' '}
        <Icon className="icon-desktop" size="large" name="desktop" />
      </div>
    );
    const mobileAndDesktop = {
      menuItem: { key: 'Mobile & Desktop', icon: mobileDesktop },
      pane: (
        <Tab.Pane>
          <Grid columns={2} divided>
            <Grid.Row>
              <Grid.Column>{this.renderMobileAd(preview)}</Grid.Column>
              <Grid.Column>{this.renderDesktopAd(preview)}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
      )
    };

    if (onlyMobile) {
      return [mobileAd];
    }

    if (instagramStoryIframeData) {
      return [instagramStory];
    }

    return [mobileAd, desktopAd, mobileAndDesktop, instagramStory];
  };

  scrollToAccordion = (id) => {
    const component = document.querySelector(id);
    if (typeof component !== 'undefined' && component !== null) {
      component.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  };

  handleAccordionClick = async (index, campaignKey) => {
    this.setState({ clickedIndex: index });
    const { adPreview, token } = this.state;
    let { borderColor } = this.state;
    const {
      ad_link: adLink,
      ad_id: adId,
      campaignObjective,
      ad_name: adName
    } = adPreview;
    borderColor = false;
    const {
      accordionIndex,
      actions,
      adAccountName,
      selectedYear,
      campaignMonthName,
      setUpdateUrl,
      selectedCampaign
    } = this.props;
    if (accordionIndex[campaignKey] === index) {
      actions.adPreviewAdAccordionIndex(-1, campaignKey);
      if (this.props.setUpdateUrl) {
        updateUrl(
          adAccountName,
          selectedYear,
          campaignMonthName,
          '',
          campaignKey,
          ''
        );
      }
    } else {
      const targetingSentenceLines = await getTargetingSentencelines(
        adId,
        token
      );
      const ad = {
        id: adId,
        name: adName,
        campaign: {
          objective: campaignObjective
        }
      };

      const isCanvas = adLink ? adLink.split('canvas_doc').length > 1 : false;

      const preview = await getPreviews(
        ad,
        token,
        isCanvas,
        ad.name.split('Collection').length > 1
      );
      this.setState({
        ...this.state,
        adPreview: {
          ...adPreview,
          targetingSentenceLines,
          desktop_iframe_url: preview.desktop,
          mobile_iframe_url: preview.mobile
        },
        borderColor
      });
      actions.adPreviewAdAccordionIndex(index, campaignKey);
      if (setUpdateUrl) {
        updateUrl(
          adAccountName,
          selectedYear,
          campaignMonthName,
          index,
          campaignKey,
          ''
        );
      }
      this.scrollToAccordion(`#accordion-${index}-${selectedCampaign}`);
    }
    this.setState({ clickedIndex: -1 });
  };

  loadAdInfo = async () => {
    const { adPreview, token } = this.state;
    let { borderColor } = this.state;
    const { ad_link, ad_id: adId, campaignObjective, ad_name } = adPreview;
    const { expandAll } = this.props;

    if (adPreview.ad_status === 'ACTIVE') {
      this.setState({ isPreviewOnHold: false });
    } else {
      this.setState({ isPreviewOnHold: true });
    }
    if (expandAll || this.state.getTargetingAndPreviewQueries) {
      const targetingSentenceLines = await getTargetingSentencelines(
        adId,
        token
      );
      const ad = {
        id: adId,
        name: ad_name,
        campaign: {
          objective: campaignObjective
        }
      };
      const isCanvas =
        ad_link !== undefined ? ad_link.split('canvas_doc').length > 1 : false;

      const preview = await getPreviews(
        ad,
        token,
        isCanvas,
        ad.name.split('Collection').length > 1
      );

      this.setState({
        ...this.state,
        adPreview: {
          ...adPreview,
          targetingSentenceLines,
          desktop_iframe_url: preview.desktop,
          mobile_iframe_url: preview.mobile
        }
      });
    }

    const url = window.location.href;

    const urlForBorderParts = url.split('ad=');
    const indexFromUrl = Number(urlForBorderParts[1].split('&')[0]);

    if (
      indexFromUrl === this.props.index &&
      urlForBorderParts[1] &&
      urlForBorderParts[1].split('&')[0] !== ''
    ) {
      borderColor = true;
    } else {
      borderColor = false;
    }
    this.setState({
      ...this.state,
      borderColor
    });

    const urlParts = url.split('#');
    const isInstagramAd = checkIfAdIsForInstagram(adPreview);
    if (isInstagramAd)
      await getInstagramStoryByAdId(adId, token, this.setInstagramDataState);

    if (urlParts[1]) {
      const params = urlParts[1].split('&');
      const selectedPreview = _.find(
        params,
        (p) => p && p.indexOf('preview=') !== -1
      );
      let previewIndex = 0;
      if (selectedPreview) {
        previewIndex = selectedPreview
          .split('=')[1]
          .replace(new RegExp('%20', 'g'), ' ');
        if (previewIndex) {
          this.setState({ previewIndex, hasPreviewIndex: true });
        } else {
          previewIndex = adPreview.isCanvas ? 0 : 1;
          this.setState({ previewIndex, hasPreviewIndex: false });
        }
      } else {
        previewIndex = adPreview.isCanvas ? 0 : 1;
        this.setState({ previewIndex, hasPreviewIndex: false });
      }
    }
  };

  setInstagramDataState = (instagramData) => {
    this.setState((prevState) => ({
      ...prevState,
      instagramData
    }));
  };

  updateStateAd = async (newAd, isHold = false) => {
    const { renderAdsAfterQc, index, updateUrls } = this.props;
    const { adPreview, token, isPreviewOnHold } = this.state;
    const { ad_original_name: adOriginalName } = adPreview;

    const newName = adOriginalName.includes('-HELD')
      ? adOriginalName.split(' -HELD')[0]
      : adOriginalName;

    const data = {
      id: newAd.ad_id,
      name: isPreviewOnHold ? `${newName} -HELD` : newName
    };

    const adToRender = newAd;

    if (isHold) {
      adToRender.ad_original_name = data.name;
      adToRender.ad_name = isPreviewOnHold
        ? adToRender.ad_name.concat(' -HELD')
        : adToRender.ad_name.split(' -HELD')[0] || adToRender.ad_name;
      const res = await updateAd(data, token);
    }

    this.setState(
      {
        ...this.state,
        adPreview: {
          ...adPreview,
          ad_original_name: adToRender.ad_original_name,
          ad_name: adToRender.ad_name,
          adQc: newAd.adQc
        }
      },
      () => {
        if (renderAdsAfterQc) {
          renderAdsAfterQc([adToRender]);
        }
      }
    );
  };

  handleTabChange = (e, data) => {
    const { panes, activeIndex } = data;
    const {
      setUpdateUrl,
      adAccountName,
      selectedYear,
      campaignMonthName,
      index,
      campaignKey
    } = this.props;
    this.setState({
      previewIndex: activeIndex,
      campaignKey: panes[activeIndex].campaignKey
    });
    if (setUpdateUrl) {
      updateUrl(
        adAccountName,
        selectedYear,
        campaignMonthName,
        index,
        campaignKey,
        activeIndex
      );
    }
  };

  adNameInAdCheck = () => {
    const { adAccountName, adPreview } = this.props;
    const { facebookInfo, productSetVehicles } = adPreview || {
      facebookInfo: null,
      productSetVehicles: null
    };
    const {
      ad_body: adBody,
      ad_title: adTitle,
      description
    } = facebookInfo || {
      ad_body: '',
      ad_title: '',
      description: ''
    };
    const { data: productSetVehiclesData } = productSetVehicles || [];
    let titleAndBodyAndDescription = '';
    titleAndBodyAndDescription = `${adBody}${adTitle}${description}`;
    if (
      productSetVehiclesData &&
      productSetVehiclesData.length > 0 &&
      titleAndBodyAndDescription.includes('vehicle.dealer_name')
    ) {
      titleAndBodyAndDescription = `${adBody}${adTitle}${description}${productSetVehiclesData[0].dealer_name}`;
      if (titleAndBodyAndDescription.includes(adAccountName)) {
        return (
          <Popup
            content="Client name was found in copy"
            trigger={
              <Icon
                name="calendar check"
                color="green"
                style={{
                  marginRight: 20,
                  verticalAlign: 'unset'
                }}
                size="large"
              />
            }
            position="top right"
          />
        );
      }
      return (
        <Popup
          content="Client name not found in copy"
          trigger={
            <Icon
              name="calendar check"
              color="black"
              style={{
                marginRight: 20,
                verticalAlign: 'unset'
              }}
              size="large"
            />
          }
          position="top right"
        />
      );
    } else if (titleAndBodyAndDescription.includes(adAccountName)) {
      return (
        <Popup
          content="Client name was found in copy"
          trigger={
            <Icon
              name="calendar check"
              color="green"
              style={{
                marginRight: 20,
                verticalAlign: 'unset'
              }}
              size="large"
            />
          }
          position="top right"
        />
      );
    }

    return (
      <Popup
        content="Client name not found in copy"
        trigger={
          <Icon
            name="calendar check"
            color="black"
            style={{
              marginRight: 20,
              verticalAlign: 'unset'
            }}
            size="large"
          />
        }
        position="top right"
      />
    );
  };

  renderMobileAd = (preview) => (
    <AdPreview
      title="Mobile Ad Preview"
      maxWidthDiv={320}
      maxHeight={620}
      offsetVertical={900}
      iframe_url={preview.mobile_iframe_url}
    />
  );
  renderDesktopAd = (preview) => (
    <AdPreview
      title="Desktop Ad Preview"
      maxWidthDiv={720}
      maxHeight={762}
      offsetVertical={1500}
      iframe_url={preview.desktop_iframe_url}
    />
  );

  renderInstagramStoryAd = () => {
    const { instagramData } = this.state;
    const iframeHtml = returnIframeForInstagramStory(instagramData);
    return (
      <AdPreview
        title="Instagram Story Ad"
        maxHeight={567}
        offsetVertical={1500}
        iframe_url={iframeHtml}
      />
    );
  };

  renderAdTabs = (adTabs) => {
    const defaultIndex = this.props.compareMobileDesktop
      ? 2
      : this.state.previewIndex;
    let adActiveIndex = adTabs.length === 1 ? 0 : defaultIndex;
    if (this.state.hasPreviewIndex) {
      adActiveIndex = parseInt(defaultIndex, 10);
    }

    return (
      <Tab
        renderActiveOnly={false}
        panes={adTabs}
        activeIndex={adActiveIndex}
        onTabChange={this.handleTabChange}
      />
    );
  };

  renderTextBox = (textContent) => {
    try {
      let content = '';
      if (textContent) {
        content = textContent === '' ? '' : textContent.join('\n');
      }
      return <Form.TextArea value={content} style={{ width: '100%' }} />;
    } catch (error) {
      console.log('error occurred in renderTextBox():', error);
      return <Form.TextArea value={''} style={{ width: '100%' }} />;
    }
  };

  renderCopyButtons = (preview) => {
    const { displayCopy } = this.props;
    const {
      ad_name: adName,
      ad_title: adTitle,
      ad_body: adBody,
      ad_link: adLink,
      facebookInfo,
      campaignObjective
    } = preview || {};
    const { description: fbDescription } = facebookInfo || {};

    const adNameLowerCase = adName.toLowerCase();
    const isDAA = campaignObjective === 'PRODUCT_CATALOG_SALES';
    const linkDescription = isDAA && fbDescription ? fbDescription : adLink;
    const isInstagramAd = adNameLowerCase.includes('instagram');
    const isCarousel = typeof adTitle !== 'string';
    if (displayCopy) {
      return (
        <Grid columns={3} divided>
          <Grid.Row>
            <Grid.Column>
              {isCarousel && !isInstagramAd ? (
                this.renderTextBox(adTitle || '')
              ) : (
                <CopyToClipboard
                  text={adTitle || ''}
                  onCopy={() => {
                    this.onCopyAdContent(adTitle || '');
                  }}
                >
                  <Form.Button size="small">Copy Title</Form.Button>
                </CopyToClipboard>
              )}
            </Grid.Column>
            <Grid.Column>
              <CopyToClipboard
                text={adBody}
                onCopy={() => {
                  this.onCopyAdContent(adBody || '');
                }}
              >
                <Form.Button size="small">Copy Body</Form.Button>
              </CopyToClipboard>
            </Grid.Column>
            <Grid.Column>
              {isCarousel && !isInstagramAd ? (
                this.renderTextBox(fbDescription || '')
              ) : (
                <CopyToClipboard
                  text={linkDescription || ''}
                  onCopy={() => {
                    this.onCopyAdContent(linkDescription || adLink || '');
                  }}
                >
                  <Form.Button size="small">
                    {isDAA
                      ? 'Copy News Link Description'
                      : 'Copy Link Description'}
                  </Form.Button>
                </CopyToClipboard>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
    return null;
  };

  setAdPreviewStatus = (isPreviewOnHold) => {
    this.setState({ isPreviewOnHold });
  };

  handleLinkOpen = () => {
    this.setState({ copyLinkOpen: true });
    this.generateCopyLink();
    this.timeout = setTimeout(() => {
      this.setState({ copyLinkOpen: false });
    }, 2500);
  };

  handleLinkClose = () => {
    this.setState({ copyLinkOpen: false });
    clearTimeout(this.timeout);
  };

  generateCopyLink = () => {
    const link = window.location.href;

    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(link);
    }

    return link;
  };

  handleAdIdHover = () => {
    const { adPreview } = this.state;
    const previewAdId = adPreview.ad_id || '';
    this.setState({ adIdOpen: true, adIdText: `Ad ID: ${previewAdId}` });
    this.timeout = setTimeout(() => {
      this.setState({ adIdOpen: false });
    }, 2500);
  };

  handleAdIdClick = () => {
    const { adPreview } = this.state;
    const previewAdId = adPreview.ad_id || '';
    this.setState({
      adIdOpen: true
    });

    this.generateCopyAdId(previewAdId);
    this.timeout = setTimeout(() => {
      this.setState({ adIdOpen: false });
    }, 1250);

    toast(`Ad ID: ${previewAdId} copied to clipboard!`, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 2500,
      type: toast.TYPE.WARNING,
      hideProgressBar: false
    });
  };

  handleAdIdClose = () => {
    this.setState({ adIdOpen: false });
    clearTimeout(this.timeout);
  };

  generateCopyAdId = (adId) => {
    if (navigator && navigator.clipboard && adId !== '') {
      navigator.clipboard.writeText(adId);
    }
    return adId;
  };

  shareLink = async (ad) => {
    await this.saveOrUpdatedPresentation(ad);
    this.setState({ showForm: true });
  };

  isUTMFormat = (name, tags) => {
    let result = { result: false, status: 'question' };
    const utms = this.props.utms;
    const _fields = name.split('_');

    const fieldsValues = {};
    _fields.map((field, i) => {
      fieldsValues[this.fields[i]] = field;
      return null;
    });

    if (utms) {
      for (const key in utms) {
        if (utms[key].status === 'active') {
          const { rules } = utms[key];
          const _ands = rules.filter((rule) => rule.operator === 'AND');
          const _ors = rules.filter((rule) => rule.operator === 'OR');
          const _andsArray = this.getValidationsArray(fieldsValues, _ands);
          const _orsArray = this.getValidationsArray(fieldsValues, _ors);
          const isValidAnds =
            !_andsArray.includes(false) && _andsArray.length > 0;
          const isValidOrs = !_orsArray.includes(false) && _orsArray.length > 0;
          const isValid = isValidAnds || isValidOrs;

          if (isValid) {
            if (utms[key].code === tags) {
              result = { result: true, status: 'noTag', code: utms[key].name };
            } else {
              result = { result: false, status: 'tag', code: utms[key].name };
            }
            break;
          }
        }
      }
    }

    return result;
  };

  getValidationsArray = (fieldsValues, rules) => {
    return rules.map((rule) => {
      try {
        switch (rule.condition) {
          case 'Equals':
            return this.validateRuleContidion(fieldsValues, rule, 'equals');
          case 'Is Not Equal To':
            return !this.validateRuleContidion(fieldsValues, rule, 'equals');
          case 'Contains':
            return this.validateRuleContidion(fieldsValues, rule, 'includes');
          case 'Does Not Contain':
            return !this.validateRuleContidion(fieldsValues, rule, 'includes');
          case 'Is Empty':
            return rule.value.length === 0;
          case 'Is Not Empty':
            return rule.value.length > 0;
          default:
            return this.validateRuleContidion(fieldsValues, rule, 'equals');
        }
      } catch (e) {
        return false;
      }
    });
  };

  validateRuleContidion = (fieldsValues, rule, condition) => {
    if (condition === 'equals') {
      return (
        fieldsValues[rule.field].toLowerCase() === rule.value.toLowerCase()
      );
    }

    return fieldsValues[rule.field]
      .toLowerCase()
      .includes(rule.value.toLowerCase());
  };

  activateDeactivateAd = () => {
    const { adPreview, token } = this.state;
    const { ad_status, ad_id, ad_name } = adPreview;

    const { user } = this.props;
    const nextAdStatus = ad_status === 'PAUSED' ? 'ACTIVE' : 'PAUSED';

    this.setState(
      {
        ...this.state,
        adPreview: {
          ...this.state.adPreview,
          ad_status: nextAdStatus
        }
      },
      () => {
        updateStatusAd(ad_id, token, nextAdStatus);

        const fullname = getFullNameOrUserName(user);

        const parameters = {
          from: 'alexia@constellationagency.com',
          fromName: 'Constellation Agency',
          to: 'campaign@constellationagency.com',
          toName: fullname,
          subject:
            this.state.adPreview.ad_status === 'PAUSED'
              ? `Ad has been turned OFF by ${fullname}`
              : `Ad has been turned ON by ${fullname}`,
          template: 'QCNotificationTemplate',
          adName: ad_name,
          adLink: this.generateCopyLink(),
          adShortLink: 'Link',
          adUser: fullname,
          adStatus:
            this.state.adPreview.ad_status === 'PAUSED'
              ? 'Ad turned off'
              : 'Ad turned on',
          adNote: 'No notes attached'
        };

        // if (window.location.hostname === 'alexia.constellationagency.com') {
        this.sendEmail(parameters);
        // }
      }
    );
  };

  sendEmail = async (parameters) => {
    try {
      const result = await makePost('email', parameters);
      if (result.statusCode === 200) {
        toast('The email has been sent successfully', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
          type: toast.TYPE.ERROR,
          hideProgressBar: true
        });
      } else if (
        result.statusCode === 500 &&
        result.error.indexOf('Email address is not verified') >= 0
      ) {
        toast(
          'Your email has not been approved. Please contact Alexia admin.',
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 3000,
            type: toast.TYPE.ERROR,
            hideProgressBar: true
          }
        );
      } else {
        toast('There was an error sending the email', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
          type: toast.TYPE.ERROR,
          hideProgressBar: true
        });
      }
    } catch (ex) {
      toast('There was an error sending the email', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
        type: toast.TYPE.ERROR,
        hideProgressBar: true
      });
    }
  };

  renderUTMButton = (preview, isFormated) => {
    const eventGroupName =
      preview.campaignObjective === 'PRODUCT_CATALOG_SALES'
        ? this.props.eventGroupName
        : '';
    if (preview.targetingSentenceLines) {
      return (
        <Popup
          size="mini"
          position="top right"
          trigger={
            <Button size="medium" color={isFormated.result ? 'blue' : 'red'}>
              Audience &amp; UTM
            </Button>
          }
          content={renderPopupContent(
            preview.targetingSentenceLines.targetingsentencelines
              .targetingsentencelines,
            preview.url_tags,
            eventGroupName,
            preview.productSetName,
            preview.productCatalogName
          )}
          on="hover"
        />
      );
    }
    return null;
  };

  renderContent = (preview, index, campaignKeyArg, isFormated) => {
    const {
      shareLink,
      adIdOpen,
      adIdText,
      copyLinkOpen,
      showForm
    } = this.state;
    const {
      accordionIndex,
      expandAll,
      getFbToken,
      campaignKey,
      adAccountName,
      user,
      campaignMonthName,
      selectedYear,
      forceFamilyUpdate,
      actions
    } = this.props;
    const {
      ad_status: adStatus,
      ad_review_feedback: adReviewFeedback,
      lead_form_name: leadFormName,
      canvas_name: canvasName,
      productSetName,
      start_time: startTime,
      end_time: endTime,
      adReport
    } = preview;
    let urlString =
      shareLink !== null
        ? (urlString = `${window.location.protocol}//${window.location.host}${window.location.pathname}/${shareLink}`)
        : '';
    urlString = urlString
      .replace('preview', 'presentations')
      .replace('list', 'detail');
    const activeIndexes = accordionIndex;
    const adTabs = this.getTabAds(preview);
    const isActive = activeIndexes[campaignKeyArg] === index || expandAll;
    return (
      <Accordion.Content active={isActive}>
        <div key={index} className="header-container generic-content">
          <Segment basic style={{ padding: 0 }}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={5}>
                  <h3>
                    {this.renderAdStatus(adStatus, adReviewFeedback)}
                    <Popup
                      trigger={
                        <Icon
                          className="preview-accordion-share-link"
                          name="linkify"
                          style={{ outline: 'none', opacity: 0.85 }}
                        />
                      }
                      content="Copied to clipboard!"
                      on="click"
                      open={copyLinkOpen}
                      onClose={this.handleLinkClose}
                      onOpen={this.handleLinkOpen}
                      position="top left"
                    />
                    <span
                      role="button"
                      onClick={this.handleAdIdClick}
                      tabIndex={0}
                      style={{ outline: 'none', opacity: 0.85 }}
                    >
                      <Popup
                        trigger={
                          <Icon
                            className="preview-accordion-share-link"
                            name="file alternate outline"
                          />
                        }
                        on="hover"
                        content={adIdText}
                        open={adIdOpen}
                        onClose={this.handleAdIdClose}
                        onOpen={this.handleAdIdHover}
                        position="top left"
                      />
                    </span>
                    <Icon
                      className="preview-accordion-share-link"
                      name="share square"
                      onClick={() => this.shareLink(preview)}
                      style={{ outline: 'none', opacity: 0.85 }}
                    />
                    <ModalShareLink
                      urlString={urlString}
                      showForm={showForm}
                      closeForm={this.closeForm}
                    />
                  </h3>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column />
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={5}>
                  {renderDestinationUrls(preview.destination_url)}
                  {renderLeadFormName(leadFormName)}
                  <CanvasPreview
                    canvasObj={canvasName}
                    destinationUrl={preview.destinationUrl}
                    productSetName={productSetName}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  {this.renderUTMButton(preview, isFormated)}
                  <Divider hidden />
                  <div>
                    Start Date: <strong>{startTime}</strong>
                  </div>
                  <div>
                    End Date: <strong>{endTime}</strong>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider hidden />
            {this.renderCopyButtons(preview)}
            <Divider hidden />
            {this.renderAdTabs(adTabs, preview)}
            <Divider hidden />
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={1} verticalAlign="middle">
                  <Label color={!adStatus ? 'orange' : 'teal'} ribbon>
                    Ad QC
                  </Label>
                </Grid.Column>
                <Grid.Column width={14}>
                  <AdNotesQC
                    isPreviewActive={isActive}
                    expandAll={expandAll}
                    tabName={campaignKey}
                    adPreview={preview}
                    updateParentState={this.updateStateAd}
                    getFbToken={getFbToken}
                    adAccountName={adAccountName}
                    generateCopyLink={this.generateCopyLink}
                    setAdPreviewStatus={this.setAdPreviewStatus}
                    forceFamilyUpdate={forceFamilyUpdate}
                    adPreviewAdAccordionIndex={
                      actions.adPreviewAdAccordionIndex
                    }
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                  <ErrorReportModal
                    updateErrorAd={this.updateStateAd}
                    ad={preview}
                    errorReport={adReport}
                    user={user}
                    month={campaignMonthName}
                    year={selectedYear}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </div>
      </Accordion.Content>
    );
  };

  renderAdStatus = (adStatus, adReviewFeedback = null) => {
    const { isPreviewOnHold } = this.state;
    const isAdDisapproved = adStatus === 'DISAPPROVED';

    let finalAdStatus = false;

    if (isAdDisapproved) {
      let reason = 'Check FB Ad manager for details';
      const { global } = adReviewFeedback || {};
      if (global) {
        const feedbackKeys = Object.keys(global);
        if (feedbackKeys.length === 1) {
          reason = `Reason: ${global[feedbackKeys[0]]}`;
        }
        if (feedbackKeys.length > 1) {
          feedbackKeys.forEach((key, index) => {
            reason = `Reason #${index + 1}: ${global[key]}`;
          });
        }
      }
      return (
        <div>
          <Popup
            wide="very"
            content={reason}
            position="right center"
            trigger={
              <Label size="large" color="red" basic>
                <Icon name="warning sign" /> Disapproved
              </Label>
            }
          />
          <Divider hidden />
        </div>
      );
    }

    if (adStatus === 'ACTIVE') {
      finalAdStatus = adStatus === 'ACTIVE' && !isPreviewOnHold;
    }

    return (
      <div>
        <Popup
          flowing
          on="click"
          trigger={
            finalAdStatus ? (
              <Button size="large" color="green" basic>
                <Icon name="check" /> Active
              </Button>
            ) : (
              <Button size="large" basic>
                <Icon name="circle" /> Inactive
              </Button>
            )
          }
        >
          <span>Are you sure you want to change the status of this ad? </span>
          <Button onClick={this.activateDeactivateAd}>Yes</Button>
        </Popup>
        <Divider hidden />
      </div>
    );
  };

  renderTitles = (preview, index, campaignKeyArg) => {
    const {
      accordionIndex,
      expandAll,
      campaignKey,
      campaignMonth
    } = this.props;

    const {
      adQc,
      ad_original_name: adOriginalName,
      ad_name: adName,
      url_tags: urlTags,
      desktop_iframe_url: desktopIframeUrl,
      mobile_iframe_url: mobileIframeUrl,
      ad_id: adId,
      adObjective
    } = preview;

    const onHold = adQc ? adQc.on_hold : false;

    const activeIndexes = accordionIndex;
    const colorRow = getColorRow(preview);
    const isHold = adQc && onHold;
    const isFormated = this.isUTMFormat(adOriginalName, urlTags);

    const {
      result: isFormatedResult,
      status: isFormatedStatus,
      code: isFormatedCode
    } = isFormated;

    const previewAdName = adOriginalName || adName;

    const urls = {
      desktopUrl: desktopIframeUrl,
      mobileUrl: mobileIframeUrl
    };

    const previewQc = adQc;

    const { borderColor, clickedIndex } = this.state;

    if (clickedIndex === index) {
      return (
        <Segment>
          <Dimmer active>
            <Loader />
          </Dimmer>

          <Image src="https://react.semantic-ui.com/images/wireframe/short-paragraph.png" />
        </Segment>
      );
    }
    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <Accordion.Title
                style={{
                  background: colorRow,
                  color: colorRow ? 'white' : null,
                  border: borderColor ? '1px solid blue' : null
                }}
                active={activeIndexes[campaignKeyArg] === index || expandAll}
                index={index}
              >
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={isFormatedResult ? 14 : 13}>
                      <a
                        style={{ color: '#000000', textDecoration: 'none' }}
                        tabIndex={0}
                        role="button"
                        onClick={() =>
                          this.handleAccordionClick(index, campaignKeyArg)
                        }
                      >
                        <Icon name="dropdown" />
                      </a>
                      <WrapperAdCheckbox
                        adName={previewAdName}
                        adId={adId}
                        creative={adObjective}
                        campaignKey={campaignKey}
                        campaignMonth={campaignMonth}
                        urls={urls}
                        previewQc={previewQc}
                      />
                      <a
                        role="button"
                        tabIndex={0}
                        style={{
                          color: '#000000',
                          textDecoration: 'none',
                          fontSize: '16px'
                        }}
                        onClick={() =>
                          this.handleAccordionClick(index, campaignKeyArg)
                        }
                      >
                        {adName}
                      </a>
                    </Grid.Column>
                    <Grid.Column
                      width={isFormatedResult ? 2 : 3}
                      textAlign="right"
                    >
                      {this.adNameInAdCheck()}
                      {!isFormatedResult && (
                        <Popup
                          trigger={
                            <Icon
                              name={
                                isFormatedStatus === 'tag' ? 'tag' : 'question'
                              }
                              color={isHold ? 'grey' : 'red'}
                              style={{
                                marginRight: 30,
                                verticalAlign: 'unset'
                              }}
                              size="large"
                            />
                          }
                          content={
                            isFormatedStatus === 'tag'
                              ? isFormatedCode
                              : 'No rule matches this ad name'
                          }
                        />
                      )}
                      {renderErrorReport(preview)}
                      {renderHoldAd(preview)}
                      {renderNoteWarning(preview)}
                      {renderPopupQCOrCheckbox(preview, 'qc1', this.props)}
                      {renderPopupQCOrCheckbox(preview, 'qc2', this.props)}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Accordion.Title>
              {this.renderContent(preview, index, campaignKey, isFormated)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  };

  render() {
    const { index, campaignKey } = this.props;
    const { adPreview } = this.state;

    return (
      <div id={`accordion-${index}-${campaignKey}`} className="accordion-item">
        {this.renderTitles(adPreview, index, campaignKey)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, adPreview, adQc } = state;
  const {
    accordionIndex,
    expandAllAds,
    displayCopyButtons,
    compareMobileDesktop,
    selectedAds,
    showCheckboxes
  } = adPreview;
  return {
    user,
    accordionIndex,
    expandAll: expandAllAds,
    displayCopy: displayCopyButtons,
    compareMobileDesktop,
    selectedAds,
    qcProcess: adQc.qcProcess,
    showCheckboxes
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

const PreviewAccordionItemWithData = compose(
  graphql(presentationBuilderDB.presentationQuery, {
    options: () => ({ variables: { name: 'ALEXIA Test A Sept2017' } })
  }),
  graphql(presentationBuilderDB.updateQuery, {
    props: ({ mutate }) => ({
      update: (presentation) =>
        mutate({
          variables: {
            name: presentation.name,
            presentation: _.omit(presentation, [
              'id',
              'url',
              'createdAt',
              'name',
              '__typename'
            ])
          },
          updateQueries: {
            getPresentations: (prev, { mutationResult }) => {
              const newPresentation =
                mutationResult.data.updatePresentationByName;
              return newPresentation;
            }
          }
        })
    })
  }),
  graphql(presentationBuilderDB.submitRepository, {
    props: ({ mutate }) => ({
      submit: (presentation) => mutate({ variables: { presentation } })
    })
  })
)(PreviewAccordionItem);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviewAccordionItemWithData);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/PreviewAccordionItem.js